import type { RouteRecordRaw } from 'vue-router'

const modules = import.meta.globEager('./modules/**/*.ts')
const routeModules: RouteRecordRaw[] = []

Object.keys(modules).map((key) => {
  const mod = modules[key].default || {}
  const mods = Array.isArray(mod) ? [...mod] : [mod]
  routeModules.push(...mods)
})

export const asyncRoutes = [...routeModules]

export const ANONYMOUS_ROUTES = ['NotFound', 'Redirect', 'ProductInfoManagement']
